import { GrowthBookOptions, growthBookService } from '@/services/growthbookService'
import Vue from 'vue'

export default {
  async install (vue: typeof Vue, options: GrowthBookOptions) {
    await growthBookService.initializeGrowthBook(options)
  },
}
